import { IAppParams } from "../models";
import { safe, generateRequest } from "../utils";
import { FILTER_FOCUS_PROPERTY } from "../config";
import { ENDPOINTS } from "../config";

export function getViewFundList(appParams: IAppParams): string {
    let { region, clienttype, productrange } = appParams;
    if (region && clienttype && productrange) {
        return `view_${region}_${clienttype}_${productrange}`;
    }
    return '';
}

export function getFocusFundList(appParams: IAppParams): string {
    let { region, clienttype, productrange } = appParams;
    if (region && clienttype && productrange) {
        return `focus_${region}_${clienttype}_${productrange}`;
    }
    return '';
}

function isFocusLimited(search) {
    return safe(() => search.filter(s => s.property === "__focus")[0].values.filter(v => v.toLowerCase() === 'featured').length > 0, false);
}

export function getFundListForFundSearch(search, appParams: IAppParams) {
    return getViewFundList(appParams);
}

export function getFundListForShareClassSearch(search, appParams: IAppParams) {
    let isFocused = isFocusLimited(search);
    return isFocused ? getFocusFundList(appParams) : getViewFundList(appParams);
}


export async function fetchFundLists(options = {}): Promise<any[]> {
    const response = await fetch(ENDPOINTS.config.listfundlists, generateRequest("POST", options));

    if (response.status >= 200 && response.status < 400) {
        const body = (await response.json());
        if (body) {
            return body;
        }
        return [];
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/client/utils/fundlist.ts